import styled from "styled-components";

export const Container = styled.div`
  height: 12rem;
  width: 15rem;
`;

export const TextContainer = styled.div`
  margin-bottom: 0.5rem;
`;
